import d3Pie from './d3Pie'
export default d3Pie
